type Callable<P extends Array<any>, R> = { (...p: P): Promise<R> }

export default function burstThrottle<P extends Array<any>, R>(
  fn: Callable<P, R>,
  limitCount: number,
  limitIntervalInMs: number,
  queueLimit = 100
): Callable<P, R> {
  const queue: Array<{ (): void }> = []
  let currentCount = 0
  let currentIntervalStart = Date.now()

  let execution = null
  let nextExecution = null
  const executeQueue = () => {
    if (execution == null) {
      execution = Date.now()

      if (execution - currentIntervalStart > limitIntervalInMs) {
        // começa um novo intervalo
        currentCount = 0
        currentIntervalStart = execution
      }
      while (currentCount < limitCount && queue.length > 0) {
        // desenfileira até o limite do intervalo
        const dequeued = queue.shift()
        if (dequeued) {
          currentCount++
          dequeued()
        }
      }
      //se ainda existe itens na fila, agenda próxima execução
      if (nextExecution == null && queue.length > 0) {
        nextExecution = setTimeout(() => {
          nextExecution = null
          executeQueue()
        }, 1 + limitIntervalInMs - (execution - currentIntervalStart))
      }
      execution = null
    }
  }

  return (...p: P): Promise<R> => {
    if (queue.length >= queueLimit) {
      return Promise.reject('Call limit exceeded')
    }
    return new Promise<R>((res, rej) => {
      let executed = false // proteção para não executar mais de uma vez
      queue.push(() => {
        if (!executed) {
          executed = true
          fn(...p)
            .then((r) => {
              res(r)
            })
            .catch((err) => {
              rej(err)
            })
        }
      })
      executeQueue()
    })
  }
}
